module.exports = (__webpack_require__(/*! dll-reference __kbnSharedDeps_npm__ */ 4))(1799);